import { FiAlertTriangle } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

export const BannerDeletedAdmin = ({ time }: { time: string }) => {
  const { t } = useTranslation();
  return (
    <div className="banner-alert banner-alert--warning">
      <div>
        <FiAlertTriangle fontSize={20} color="#FF4D4F" />
      </div>
      <div className="banner-alert-content">
        <span className="banner-label">{t('banner.deleted-admin.title', { time })}</span>
      </div>
    </div>
  );
};

export default BannerDeletedAdmin;